import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { CarrierCleanupQuery, CarrierCleanupQueryResult, CarrierReplacement } from './cleanup-administration.model';

@Injectable({
  providedIn: 'root'
})
export class CleanupAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public findCarrierByQuery(query: CarrierCleanupQuery): Observable<CarrierCleanupQueryResult[]> {
    return this.appServerAPI.execute<CarrierCleanupQueryResult[]>('/client/admin/cleanup/find-carriers', query);
  }

  public replaceCarriers(replacement: CarrierReplacement): Observable<CarrierCleanupQueryResult[]> {
    return this.appServerAPI.execute<CarrierCleanupQueryResult[]>('/client/admin/cleanup/replace-carriers', replacement);
  }
}
